var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from '@xstyled/styled-components';
import { th } from '@xstyled/system';
var Divider = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 1px;\n  border-top: 1;\n  border-top-color: borderDark;\n  border-bottom: 1;\n  border-bottom-color: ", ";\n\n  width: 98%;\n  margin-left: 2;\n"])), th('colors.borderLightest'));
Divider.displayName = 'List.Divider';
export default Divider;